module.exports = __webpack_public_path__ + "img/keyBuckle_4.949bd3c8.jpg";